import { Inject, Injectable } from '@angular/core';
import { DwOrmDataServiceToken, DwOrmDataService, DwMetaDataServiceToken, DwMetaDataService, DwEventService, DwCacheService, DwQueryFilter, DwQueryHelper, DwOrmData } from '@devwareapps/devware-cap';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppMetaDataService, EthosWachterDepartmentEntity } from '../../../meta-data/app-meta-data.service';
import { CodeValuePermitType, PermitRequestEntity, PermitRequestPermitEntity, PermitsMetaDataService } from '../../permits/meta-data/permits-meta-data.service';

@Injectable({
  providedIn: 'root'
})
export class PermitRequestService {

  constructor(
    @Inject(DwOrmDataServiceToken) private dwOrmDataService: DwOrmDataService,
    @Inject(DwMetaDataServiceToken) private dwMetaDataService: DwMetaDataService,
    private dwEventsService: DwEventService,
    private dwCacheService: DwCacheService,
  ) { }

  getPermitTypeName(type: number) {
    return  type == CodeValuePermitType.DataVoice ? "Voice & Data" :
            type == CodeValuePermitType.CCTV ? "CCTV" :
            type == CodeValuePermitType.AudioVisual ? "Audio/Visual" :
            type == CodeValuePermitType.FireAlarm ? "Fire Alarm" :
            type == CodeValuePermitType.Electrical ? "Electrical" :
            type == CodeValuePermitType.AccessControl ? "Access Control" :
            type == CodeValuePermitType.BurglarAlarm ? "Burglar Alarm" : "";
  }

  /**
  * Save a new PermitRequest-Permit entity to get the related data betwen a Permit Request
  * and a Child Permit
  * @param permitREquestPermitEntity: Permit-Request to Permit entity to be stored in the database
  * @returns observable with the save result
  **/

  getPermitRequestById(permitRequestId: string): Observable<PermitRequestEntity> {
    const md = new PermitsMetaDataService();

    const qh = new DwQueryHelper();

    const query = md.PermitRequest.CreateQuery()

    query.AddFilterAnd(qh.filters.Equal(md.PermitRequest.PermitRequestId, permitRequestId));
    query.AddPrefetchPath(md.PermitRequest.Relations.PermitRequestPermitType)

    let data = this.dwOrmDataService.executeQuerySingle(query);

    return data;
  }

  getPermitOnPermitRequest(permitRequestId: string) {
    const md = new PermitsMetaDataService();
    const query = md.PermitRequest.CreateQuery();

    const filter: DwQueryFilter = new DwQueryFilter();
    filter.Attr = md.PermitRequest.PermitRequestId;
    filter.Value = permitRequestId;
    query.AddFilterAnd(filter)
    return this.dwOrmDataService.executeQuery(query);
  }

  getWachterDivisionId(wachterDeparmentId: number): Observable<number> {

    return this.getWachterDepartments()
      .pipe(map(departments => {
        return departments.find(d => d.WachterDepartmentId == wachterDeparmentId)?.WachterDivisionId;
      }))
  }

  /**
   * Old method but was loading the data multiple times
   * @param wachterDeparmentId 
   * @returns 
   */
  private loadWachterDivisionId(wachterDeparmentId: number): Observable<number> {

    const md = new AppMetaDataService();
    var qh = new DwQueryHelper();

    const query = md.EthosWachterDepartment.CreateQuery();


    query.AddFilterAnd(qh.filters.Equal(md.EthosWachterDepartment.WachterDepartmentId, wachterDeparmentId));

    query.FieldSettings.IncludeRootItemFields = false;
    query.AddField(md.EthosWachterDepartment.WachterDivisionId);

    return this.dwOrmDataService.executeQuerySingle(query)
      .pipe(map((dept: EthosWachterDepartmentEntity) => {
        return dept?.WachterDivisionId;

      }));
  }


  getWachterDepartments() : Observable<EthosWachterDepartmentEntity[]> {

    return this.dwCacheService.getWithOptions("wachterDepartments", this.loadWachterDepartments());
  }


  private loadWachterDepartments(): Observable<EthosWachterDepartmentEntity[]> {
    const md = new AppMetaDataService();
    var qh = new DwQueryHelper();

    const query = md.EthosWachterDepartment.CreateQuery();

    query.FieldSettings.IncludeRootItemFields = false;
    query.FieldSettings.LoadAllLookupDisplayFields = true;

    query.AddField(md.EthosWachterDepartment.WachterDivisionId);
    
    query.AddField(md.EthosWachterDepartment.WachterDepartmentId);

    return this.dwOrmDataService.executeQuery(query);
  }
}
